import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 30px;\n  box-sizing: border-box;\n  width: 100%;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n  box-sizing: border-box;\n  width: 100%;\n  ", "\n  @media screen and (max-width: ", "px) {\n    padding: 30px;\n  }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        border-radius: 0;\n        border: none;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border: 1.5px solid ", ";\n      border-radius: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      min-height: ", "px;\n      display: flex;\n      flex-direction: column;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  background: ", ";\n  ", "\n  margin-bottom: 20px;\n  ", "\n\n  @media screen and (max-width: ", "px) {\n    margin-bottom: 10px;\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from '../utils/styling/styled-components';
var CardContainer = styled.div(_templateObject(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return (
    /**
     * When using a minHeight on the Card, we want to allow the content area to grow.
     * Adding display: flex allows this.
     */
    props.minHeight && css(_templateObject2(), props.minHeight)
  );
}, function (props) {
  return props.displayBorder && css(_templateObject3(), function (props) {
    return props.theme.colors.ivory;
  }, function (props) {
    return props.theme.borderRadius.large;
  });
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return !props.mobileOverrides.displayBorder && css(_templateObject4());
});

var Card = function Card(props) {
  var passedProps = _objectSpread({
    displayBorder: true,
    mobileOverrides: {
      displayBorder: false
    }
  }, props);

  return /*#__PURE__*/React.createElement(CardContainer, passedProps, props.children);
};

var paddingMap = {
  large: 80,
  medium: 50,
  small: 30,
  none: 0
};
var CardContent = styled.div(_templateObject5(), function (_ref) {
  var _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'small' : _ref$padding;
  return paddingMap[padding];
}, function (props) {
  return props.isContentCenterAligned && "\n    margin: auto; // Makes the content take up center aligned within available space and pins footer to the bottom.\n  ";
}, function (props) {
  return props.theme.breakpoints.sm;
});
var CardFooter = styled.div(_templateObject6());
export { Card, CardFooter, CardContent };